// One line at the bottom of the screen for a few seconds ("Saved", or what went wrong).
import { useSyncExternalStore } from "react";

let current = { msg: "", on: false };
let timer: ReturnType<typeof setTimeout> | undefined;
const subs = new Set<() => void>();
const set = (v: typeof current) => { current = v; subs.forEach((f) => f()); };

export function toast(msg: string) {
  set({ msg, on: true });
  clearTimeout(timer);
  timer = setTimeout(() => set({ msg, on: false }), 3200);
}

export function Toaster() {
  const t = useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb); }, () => current);
  return <div id="toast" role="status" className={t.on ? "on" : ""}>{t.msg}</div>;
}
